import { AttachmentControllerService } from 'shared/api/generatedApi/services/AttachmentControllerService';

export const attachmentApi = {
  upload: (parentId: number, parentType: string, type: string, file: File | Blob) => AttachmentControllerService.upload(
    parentId,
    parentType,
    type,
    { files: [file] },
  ),
  uploadDraft: (type: string, file: File | Blob) => AttachmentControllerService.uploadDraft(type, { files: [file] }),
  list: (parentId: number, parentType: string) => AttachmentControllerService.list(parentId, parentType),
  getDownloadUrl: (attachmentUuid: string, expiry?: number) => AttachmentControllerService.downloadUrl(attachmentUuid, expiry),
  delete: (attachmentUuid: string) => AttachmentControllerService.delete1(attachmentUuid),
};
